import { Theme } from "common";

export const errorDialogStyles = {
  errorSummaryTitle: {
    "&&": {
      borderBottom: `1px solid ${Theme.palette.common.black}`,

      "&& h2": {
        display: "flex",
        alignItems: "center",
        fontWeight: "bold",

        "& svg": {
          marginRight: "6px",
        },
      },
    },
  },
  errorSummaryContent: {
    "&&": {
      padding: "0",
    },
  },
  itemTextBlock: { display: "flex", paddingBottom: "5px" },
  itemTextSpan: { minWidth: "80px", paddingRight: "5px" },
  contentListItem: {
    "&&": {
      backgroundColor: Theme.palette.common.white,
    },
  },
  warning: {
    color: Theme.palette.warning.main,
  },
};
